import React, { useEffect, useState } from 'react';
import { FiSearch, FiUsers } from 'react-icons/fi';
import { cUsers } from '../../api';
import { useLanguage } from '../../i18n';
import FollowButton from '../../components/community/FollowButton';
import UserAvatar from '../../components/community/UserAvatar';
import UserBadges from '../../components/community/UserBadges';
import { NAVY, BLUE } from '../../components/community/brand';

/** Discover every community member (search + follow / follow back). */
export default function PeoplePage() {
  const { t } = useLanguage();
  const [q, setQ] = useState('');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = (term = '') => {
    setLoading(true);
    cUsers({ q: term || undefined, limit: 30 })
      .then((res) => setItems(res?.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="mx-auto max-w-3xl px-3 lg:px-4 py-4 space-y-4">
      <header className="flex items-center gap-3">
        <span className="w-10 h-10 rounded-xl flex items-center justify-center text-white" style={{ background: NAVY }}>
          <FiUsers className="w-5 h-5" />
        </span>
        <div>
          <h1 className="font-extrabold text-lg">{t('members')}</h1>
          <p className="text-xs text-gray-500">{t('suggestedMembers')}</p>
        </div>
      </header>

      <form
        onSubmit={(e) => { e.preventDefault(); load(q.trim()); }}
        className="flex items-center gap-2 rounded-full bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 px-4 py-2.5"
      >
        <FiSearch className="w-4 h-4 text-gray-400" />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder={t('searchCommunity')}
          className="flex-1 bg-transparent outline-none text-sm dark:text-gray-100"
        />
        <button type="submit" className="px-3 py-1.5 rounded-full text-white text-xs font-bold" style={{ background: BLUE }}>
          {t('seeAll')}
        </button>
      </form>

      <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-100 dark:border-gray-800 divide-y divide-gray-100 dark:divide-gray-800">
        {loading ? (
          <p className="p-4 text-sm text-gray-400">{t('loading')}</p>
        ) : items.length === 0 ? (
          <p className="p-4 text-sm text-gray-400">{t('noPosts')}</p>
        ) : (
          items.map((p) => (
            <div key={p.id} className="flex items-center gap-3 p-3.5">
              <UserAvatar user={p} size={42} to={`/u/${p.username}`} />
              <div className="min-w-0 flex-1">
                <p className="font-semibold text-sm truncate flex items-center gap-1.5">
                  <span className="truncate">{p.name || p.username}</span>
                  <UserBadges user={p} />
                </p>
                <p className="text-[11px] text-gray-400 truncate">
                  @{p.username} · {p.followers_count} {t('followers')} · {p.posts_count} {t('posts')}
                </p>
                {p.bio && <p className="text-xs text-gray-500 line-clamp-1">{p.bio}</p>}
              </div>
              <FollowButton user={p} />
            </div>
          ))
        )}
      </div>
    </div>
  );
}
